import { Layers3, ListPlus, Tags, UtensilsCrossed } from 'lucide-react';

import { MENU_CONFIGURATION_TABS } from '../menuConfigurationConstants';
import { MenuConfigurationTab } from '../types';

interface Props {
  value: MenuConfigurationTab;
  disabled?: boolean;
  onChange: (value: MenuConfigurationTab) => void;
}

const icons = {
  CATEGORIES: Tags,
  ITEMS: UtensilsCrossed,
  MODIFIERS: ListPlus,
  ASSIGNMENTS: UtensilsCrossed,
  COMBOS: Layers3,
};

const MenuConfigurationTabs = ({ value, disabled, onChange }: Props) => (
  <nav
    aria-label="Secciones de configuración del menú"
    className="flex gap-2 overflow-x-auto border-b border-stroke px-5 py-4 dark:border-strokedark sm:px-7"
  >
    {MENU_CONFIGURATION_TABS.map((tab) => {
      const Icon = icons[tab.value];
      const active = value === tab.value;

      return (
        <button
          key={tab.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(tab.value)}
          className={`inline-flex shrink-0 items-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50 ${
            active
              ? 'border-primary bg-primary text-white shadow-sm'
              : 'border-stroke bg-white text-body hover:border-primary/40 hover:text-primary dark:border-strokedark dark:bg-boxdark dark:text-bodydark'
          }`}
        >
          <Icon className="h-4 w-4" />
          {tab.label}
        </button>
      );
    })}
  </nav>
);

export default MenuConfigurationTabs;
